import { render } from "./TheAdminClinicCreateModal.vue?vue&type=template&id=764c60ea&ts=true"
import script from "./TheAdminClinicCreateModal.vue?vue&type=script&lang=ts"
export * from "./TheAdminClinicCreateModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__